<div class="content-left-top-cornor">
    <div class="col-12 flex pb-0" *ngIf="activatedSamplesHeaderVisible">
      <div class="col-12 p-0 activatedSamplesBanner">
        <div class="col-8 p-0 text-center textStyle">
          Already received samples are now announced or activated! 
        </div>
        <div class="col-4 p-0 float-left">
          <button class="excelButton" (click)="downloadExcelFile()">Download Excel</button>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="srcExcelHeaderVisible">
      <div class="col-12 p-0 srcBanner">
        <div class="col-8 p-0 text-center textStyle">
          Sorted out samples are ready for placement!
        </div>
        <div class="col-4 p-0 float-left">
          <button class="excelSRCButton" (click)="downloadSRCExcel()">Download Excel</button>
        </div>
      </div>
    </div>
  <p-tabView (onChange)="onTabChange($event)" [activeIndex]="index">
    <p-tabPanel *ngIf="isPlateReceptionOn" [headerStyleClass]="getCSSClassForPanel('plateReception')" header="Plate Reception">
      <p-blockUI [blocked]="blocked">
        <div id="center" style="margin-top:260px; margin-left:800px;">
          <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
        </div>
      </p-blockUI>
      <div class="container-fluid mt-0">
        <div class="row">
          <div class="col-12 flex pt-0 pb-0">
            <div class="col-3">
              <div class="col-1" id="refreshPlatesDiv">
                <button pButton class="refreshPlates" icon="fa fa-refresh" (click)="getAnnounedPlates()"></button>
              </div>
              <div class="flex justify-content-between px-0">
                <span class="m-0 col-7 px-0">Number Of Plates Matching Filter: 
                  <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</span>
                </span>
                <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
              </div>
            </div>
            <div class="col-9 pb-0">
              <div class="col-12 flex pt-0 pb-0" id="topGroup">
                <div class="col-4 topDivspacing pr-0" id="topDiv">
                  <div class="ui-inputgroup" id="inputClass">
                    <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
                    <input pInputText name="UserPUID" [value]="puid" size="10" id="userID" maxlength="4" class="inputBox" placeholder="User ID" readonly />
                  </div>
                  <div class="ui-inputgroup" id="inputClass">
                    <button pButton class="theme-button noHover labelButton" type="button" label="Plate ID"></button>
                    <input pInputText name="SearchPlate" [(ngModel)]="plateToSearch" size="10" (keydown.enter)="searchForPlate()" class="inputBox" placeholder="Plate ID" />
                    <button pButton icon="fa fa-search" class="search-field-blue-end" (click)="searchForPlate()">
                    </button>
                  </div>
                  <div class="ui-inputgroup" id="inputClass">
                    <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
                    <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10" (keydown.enter)="searchForSample()" class="inputBox" placeholder="Sample ID" [hidden]="sampleSearchDisabled" />
                    <button pButton icon="fa fa-search" class="search-field-blue-end" (click)="searchForSample()">
                    </button>
                  </div>
                </div>
    
                <div class="col-5 topDivspacing pl-0 pr-0" style="text-align: left;">
                  <div class="col-12 headers">
                    <h5>
                      Plate :<strong>{{selectedPlate?.lastUpdatedPlateID}} </strong>
                    </h5>
                  </div>
                  <div class="col-12 headers">
                    <h5>
                      Status :<strong> {{selectedPlate?.status}}</strong>
                    </h5>
                  </div>
                  <div class="col-12 headers">
                    <h5>
                      Sender :<strong> {{selectedPlate?.sender}}</strong>
                    </h5>
                  </div>
                  <div class="col-12 headers">
                    <h5>
                      Sample Type: <strong> {{selectedPlate?.sampleType}} </strong>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 flex pt-0 pb-0">
            <div class="col-3">
              <div class="tableLHS1">
                <p-table [value]="plates" selectionMode="single" (onRowSelect)="showPlateInfo($event)"
                  [loading]="loading" [(selection)]="tableSelectedRow" (onRowUnselect)="removePlateSelection($event)">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="plate" scope="col">Plate ID <span *ngIf="showDueDate"><br/> (Due Date) </span></th>
                      <th class="status" scope="col">Status</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-plate>
                    <tr [pSelectableRow]="plate">
                      <td class="leftTable">
                        {{plate?.lastUpdatedPlateID}} <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span></td>
                      <td>
                        {{plate?.status}}</td> 
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <div pTooltip="All Samples before and including the selected date are getting included into the report."
                class="ui-inputgroup" style="margin-top: 1rem;margin-left: 1rem;width: 22rem !important;">
                <button pButton class="theme-button noHover labelButton" type="button" label="Date" style="width: 6rem;"></button>
                <p-calendar [(ngModel)]="dateSelected" placeholder="Sel. Date" dateFormat="dd.mm.yy" [showIcon]="true"></p-calendar>
              </div>
              <div style="margin: 1rem 0rem 0rem 8rem;">
                <label for="exported">
                  <h5>Exported</h5>
                </label>
                <input style="width: 15px;height: 15px; margin: 3%;" name="exported" type="checkbox" [(ngModel)]="exported" binary="true">
              </div>
              <div>
                <button pButton id="createBatchButton" class="buttonsRound receiptReport" label="Receipt Report" (click)="receiptReport()"></button>
              </div>
            </div>
            <div class="col-9">
              <div class="col-12" id="tableDiv">
                <p-confirmDialog class="confirm-message"></p-confirmDialog>
                <table id="batchTable" class="rightTable" aria-describedby="Unboxing Table">
                  <thead id="batchTableHeader">
                    <tr>
                      <th class="rightTableHead" scope="col">Receive Plate</th>
                      <th class="rightTableHead1" scope="col"></th>
                    </tr>
                  </thead>
                  <tbody id="batchTableBody">
                    <tr>
                      <td id="batchTableBody">
                        <div>
                          <div class="createNewBatchButtonDiv">
                            <button pButton id="createNewBatchButton" class="buttonsRound startButton" label="New Plate" (click)="clearAllFieldsForNewPlate()"></button>
                          </div>
                          <div class="col-12 flex">
                            <div class="col-6">
                              <div class="plateIDField" id="inputClass">
                                <button pButton class="theme-button noHover labelButton" type="button" label="Plate ID11"></button>
                                <input pInputText name="plateID" style="width: 9rem;" (keydown.enter)="searchForPlateAction(receivePlatePlateID, true)"
                                  [(ngModel)]="receivePlatePlateID" placeholder="Plate ID" />
                              </div>
                    
                              <span *ngFor="let plateID of plateSelectionList let index=index;">
                                <div>
                                  <input pInputText name="plateID" style="width: 9rem; margin-left: 6.9rem; height: 2rem;" [value]="plateID" readonly/>
                                  <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(index,plateID)"></button>
                                </div>
                              </span>
                            </div>
                            
                            <div class="col-6" style="width: 19rem; margin-top: 2rem;">
                            <div class="ui-inputgroup" id="inputClass">
                              <button pButton class="theme-button noHover labelButton" type="button" label="Workflow"></button>
                              <p-dropdown [style]="{'width':'65%', 'height':'2.2rem'}" placeholder="Workflow" [options]="workFlowList"
                                name="workFlowList" (onChange)="getSelectedWorkflow()" [disabled]="isScanElementDisabled()"
                                [(ngModel)]="selectedPlate.workFlow">
                              </p-dropdown>
                            </div>
    
                            <div class="ui-inputgroup" id="inputClass">
                              <button pButton class="theme-button noHover labelButton" type="button" label="Sender"></button>
                              <p-dropdown [style]="{'width':'65%','height':'2.2rem'}" placeholder="Sender" [options]="customerList"
                                name="customerList" (onChange)="getSelectedSender()" [disabled]="isScanElementDisabled()"
                                [(ngModel)]="selectedPlate.sender">
                              </p-dropdown>
                            </div>
    
                            <div class="ui-inputgroup" id="inputClass">
                              <button pButton class="theme-button noHover labelButton" type="button" label="Delivery"></button>
                              <input pInputText name="DeliveryID" style="width: 65%;" placeholder="Delivery ID" [(ngModel)]="selectedPlate.delivery"
                              />
                            </div>
                          </div>
                          </div>
                    
                          <div id="createBatchButtonDiv" class="recevedButton">
                            <button pButton id="createBatchButton" class="buttonsRound thirdButton" label="Receive Plate"
                            (click)="receivePlate()" [disabled]="receiveButtonDisable()"></button>
                            <div id="createdDateTime" class="createButton" *ngIf="isValidProcessStep('RECEIVE_PLATE')">
                              {{getProcessStepStartTimestamp('RECEIVE_PLATE') | date: 'dd.MM.yy HH:mm'}}<br>
                              {{getProcessStepStartPuid('RECEIVE_PLATE')}}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td id="processingTableBody">
                        <div *ngIf="selectedPlateMap.size === 0" style="margin-top: 1rem; margin-left: 1rem;">Samples : 0</div>
                        <div class="col-12 scanInfoDetailsDiv" *ngIf="selectedPlateMap.size === 0">
                          <div class="col-6" *ngIf="selectedPlateMap.size === 0">
                            <div class="sampleBarcode">{{scannedBarcodeToShow}}</div>
                          </div>
                        </div>
                        <div class="col-12" *ngIf="selectedPlateMap.size === 0">
                          <div class="col-10">
                            <div class="col-12 flex classDiv">
                              <div class="col-6 classDiv">
                                Position
                              </div>
                        
                              <div class="col-6 classDiv">
                                Sample ID
                              </div>
                            </div>
                          </div>
                        </div>
                        <p-tabView *ngIf="selectedPlateMap.size !== 0" [activeIndex]="activeTabIndex">
                          <ng-container *ngFor="let plateData of selectedPlateMap | keyvalue">
                            <p-tabPanel header="{{plateData.key}}">
                              <div>
                                Samples : {{ (plateData.value) ? plateData.value.length : 0}}</div>
                              <div class="col-12">
                                <div class="col-10">
                                  <div class="col-12 flex classDiv">
                                    <div class="col-6 classDiv">
                                      Position
                                    </div>
                                    <div class="col-6 classDiv">
                                      Sample ID
                                    </div>
                                  </div>
                                  <div class="col-12 classDiv">
                                    <p-table [value]="plateData.value" [scrollable]="true" scrollHeight="45vh" [loading]="loading">
                                      <ng-template pTemplate="body" let-sample>
                                        <tr>
                                          <td [class]="scanTableTdBlack">
                                            {{sample?.position}}</td>
                                          <td [class]="scanTableTdBlack">
                                            {{sample?.sampleID}}</td>
                                        </tr>
                                      </ng-template>
                                    </p-table>
                                  </div>
                                </div>
                              </div>
                            </p-tabPanel>
                          </ng-container>
                        </p-tabView>
                        </td>
                        </tr>
                        </tbody>
                </table>
              </div>
              <div class="col-12">
                <div id="createdDateTime" class="storeButtonTimeStamp" *ngIf="isValidProcessStep('STORE_PLATE')">
                  {{getProcessStepStartTimestamp('STORE_PLATE') | date: 'dd.MM.yy HH:mm'}} <br />
                  {{getProcessStepStartPuid('STORE_PLATE')}}
                </div>
                <button pButton id="createBatchButton" class="buttonsRound storeButton" label="Store Plate" (click)="storePlate()"></button>
                <p-dropdown placeholder="Select Storage Location" [options]="storageList" optionLabel="storageName" optionValue="storageName"
                  name="storageList" [(ngModel)]="selectedStorage" *ngIf="storageList.length > 1">
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel *ngIf="isSampleScanOn" [headerStyleClass]="getCSSClassForPanel('sampleScan')" header="Sample Scan">
      <ng-template pTemplate="content">
        <app-icbf-workflow [selectedProcessFlows]="selectedProcessFlows" [scannedPlateID]="scannedPlateID" #icbfReception></app-icbf-workflow>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>
